export default "__VITE_ASSET__DqPfhsQx__"